import React, { Component } from "react";
import Link from "gatsby-link";
import "./_intro.scss";

class Intro extends Component {
  render() {
    return (
      <div className="intro__row">
        <div className="intro__body-copy--intro">
            <p>AFROSOC advocates for and builds power with DSA’s Black/POC membership and their communities. We pursue this work to help build a multiracial working-class base, the only viable strategy for securing a socialist future.</p>
            <p>Through public and internal education and agitation, we aim to continue the legacy of the Black radical tradition, as well as the radical traditions of other oppressed minorities. Our goal is to act as a network that will support and develop non-white DSA members as leaders in the organization.</p>
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/components/intro/intro.js